"use client"
import { Link } from 'react-router-dom';
import React, { useState } from 'react';

const ResponsiveMenu = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const active = (value) => setActiveMenu(value === activeMenu ? null : value),
    activeIcon = (value) => (activeMenu == value ? "mean-clicked" : ""),
    activeSubMenu = (value) =>
    value == activeMenu ? { display: "block" } : { display: "none" };

  return (
    <>    
    <ul>
        <li><Link to='/'>Home</Link></li>  
        <li><Link to='/about-us'>About Us</Link></li>
        <li><Link to='/services'>Services</Link></li>
        
        {/* Replaced dropdown with a single direct link to /gallery */}
        <li><Link to='/gallery'>Gallery</Link></li>
        
        {/* <li><Link to='/blog'>Blog</Link></li> */}
        <li><Link to='/contact-us'>Contact Us</Link></li>      
    </ul>  
    </>
  );
};

export default ResponsiveMenu;